import React, { useState } from 'react';
import axios from 'axios';

const LeadMagnet = () => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Execute reCAPTCHA if available
      let token = '';
      if (window.grecaptcha) {
        token = await window.grecaptcha.execute('6LdJcEcsAAAAAJ71b7AI8WMqpmrSFFf4U2PLauNV', { action: 'lead_magnet' });
      }
      
      await axios.post('/api/lead-magnet', { 
        email, 
        name, 
        recaptchaToken: token 
      });
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const checklistItems = [
    "Full legal name (including maiden name)",
    "Date and place of birth",
    "Date, place, and cause of death",
    "Current residence",
    "Education history",
    "Career and professional accomplishments",
    "Military service details",
    "Hobbies, interests, and passions",
    "Community involvement and memberships",
    "Surviving family members",
    "Predeceased family members",
    "Funeral service details",
    "Memorial donation information"
  ];

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-10">
          
          {/* Hero Section */}
          <div className="glass-card text-center mb-5">
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📋</div>
            <h1 className="commercial-heading mb-3" style={{ fontSize: '2.5rem' }}>
              Free: Obituary Writing Checklist
            </h1>
            <p className="lead" style={{ color: '#4a5568', fontSize: '1.3rem', maxWidth: '700px', margin: '0 auto 1.5rem' }}>
              Everything you need to gather before writing an obituary. This comprehensive checklist 
              ensures you don't miss any important details during a difficult time.
            </p>
            
            {/* Social Sharing Buttons */}
            <div className="d-flex gap-2 flex-wrap justify-content-center">
              <span style={{ color: '#4a5568', fontWeight: '500', marginRight: '0.5rem', alignSelf: 'center' }}>Share this resource:</span>
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent('https://obitauthor.com/free-obituary-checklist')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="social-share-btn"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  background: 'rgba(59, 89, 152, 0.1)',
                  color: '#3b5998',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease'
                }}
                title="Share on Facebook"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a
                href={`https://twitter.com/intent/tweet?url=${encodeURIComponent('https://obitauthor.com/free-obituary-checklist')}&text=${encodeURIComponent('Free obituary writing checklist - helpful resource for a difficult time')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="social-share-btn"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  background: 'rgba(29, 161, 242, 0.1)',
                  color: '#1da1f2',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease'
                }}
                title="Share on Twitter"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </a>
              <button
                onClick={() => {
                  navigator.clipboard.writeText('https://obitauthor.com/free-obituary-checklist');
                  alert('Link copied to clipboard!');
                }}
                className="social-share-btn"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  background: 'rgba(212, 175, 55, 0.1)',
                  color: '#d4af37',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                title="Copy link"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
                  <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
                </svg>
              </button>
            </div>
          </div>

          <div className="row">
            {/* Preview Column */}
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="glass-card h-100">
                <h2 style={{ 
                  color: '#1a1a2e', 
                  fontSize: '1.5rem',
                  marginBottom: '1.5rem',
                  fontFamily: 'Georgia, serif'
                }}>
                  What's Included:
                </h2>
                <ul style={{ listStyle: 'none', padding: 0 }}>
                  {checklistItems.map((item, index) => (
                    <li 
                      key={index}
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: '12px',
                        marginBottom: '0.75rem',
                        color: '#4a5568',
                        fontSize: '1rem',
                        lineHeight: '1.5'
                      }}
                    >
                      <span style={{
                        color: '#d4af37',
                        fontSize: '1.1rem',
                        minWidth: '20px'
                      }}>
                        ☐
                      </span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
                <div style={{
                  marginTop: '1.5rem',
                  padding: '1rem',
                  background: 'rgba(212, 175, 55, 0.1)',
                  borderRadius: '12px',
                  textAlign: 'center'
                }}>
                  <p style={{ color: '#4a5568', marginBottom: '0', fontSize: '0.95rem' }}>
                    <strong>PLUS:</strong> Tips for gathering information and writing with compassion
                  </p>
                </div>
              </div>
            </div>

            {/* Form Column */}
            <div className="col-lg-6">
              <div className="glass-card h-100">
                {success ? (
                  <div className="text-center py-5">
                    <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>✨</div>
                    <h2 style={{ color: '#1a1a2e', marginBottom: '1rem' }}>Check Your Email</h2>
                    <p style={{ color: '#4a5568', fontSize: '1.1rem' }}>
                      Your free obituary checklist is on its way to <strong>{email}</strong>
                    </p>
                    <p style={{ color: '#718096', fontSize: '0.95rem', marginTop: '1.5rem' }}>
                      Didn't receive it? Check your spam folder or{' '}
                      <button 
                        onClick={() => { setSuccess(false); setEmail(''); setName(''); }}
                        style={{ 
                          background: 'none', 
                          border: 'none', 
                          color: '#d4af37', 
                          textDecoration: 'underline',
                          cursor: 'pointer' 
                        }}
                      >
                        try again
                      </button>
                    </p>
                    <hr style={{ margin: '2rem 0', borderColor: 'rgba(0, 0, 0, 0.1)' }} />
                    <p style={{ color: '#4a5568' }}>
                      Need help writing the obituary?
                    </p>
                    <a href="/" className="btn btn-primary btn-lg">
                      Get Started - $9.99
                    </a>
                  </div>
                ) : (
                  <>
                    <h2 style={{ 
                      color: '#1a1a2e', 
                      fontSize: '1.5rem',
                      marginBottom: '0.5rem',
                      fontFamily: 'Georgia, serif'
                    }}>
                      Get Your Free Checklist
                    </h2>
                    <p style={{ color: '#718096', marginBottom: '1.5rem' }}>
                      We'll send the PDF directly to your inbox.
                    </p>
                    
                    <form onSubmit={handleSubmit}>
                      <div className="mb-3">
                        <label className="form-label" style={{ color: '#4a5568', fontWeight: '500' }}>
                          First Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          placeholder="Your first name"
                          required
                          style={{
                            borderRadius: '12px',
                            padding: '0.75rem 1rem',
                            border: '2px solid rgba(0, 0, 0, 0.1)'
                          }}
                        />
                      </div>
                      
                      <div className="mb-4">
                        <label className="form-label" style={{ color: '#4a5568', fontWeight: '500' }}>
                          Email Address
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          placeholder="your@email.com"
                          required
                          style={{
                            borderRadius: '12px',
                            padding: '0.75rem 1rem',
                            border: '2px solid rgba(0, 0, 0, 0.1)'
                          }}
                        />
                      </div>

                      {error && (
                        <div className="alert alert-danger mb-3" style={{ borderRadius: '12px' }}>
                          {error}
                        </div>
                      )}

                      <button 
                        type="submit" 
                        className="btn btn-primary btn-lg w-100"
                        disabled={loading}
                        style={{ padding: '0.875rem' }}
                      >
                        {loading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" />
                            Sending...
                          </>
                        ) : (
                          <>
                            <i className="bi bi-download me-2"></i>
                            Send My Free Checklist
                          </>
                        )}
                      </button>
                    </form>

                    <div style={{ 
                      marginTop: '1.5rem', 
                      padding: '1rem',
                      background: 'rgba(0, 0, 0, 0.03)',
                      borderRadius: '12px',
                      textAlign: 'center'
                    }}>
                      <p style={{ color: '#718096', fontSize: '0.85rem', marginBottom: 0 }}>
                        🔒 We respect your privacy. Your information is secure.
                      </p>
                    </div>

                    <div className="text-center mt-4">
                      <p style={{ color: '#718096', fontSize: '0.9rem' }}>
                        Ready to write now?{' '}
                        <a href="/" style={{ color: '#d4af37', textDecoration: 'none' }}>
                          Create an obituary →
                        </a>
                      </p>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>

          {/* Testimonial */}
          <div className="glass-card text-center mt-4">
            <div style={{ maxWidth: '700px', margin: '0 auto' }}>
              <p style={{ 
                color: '#4a5568', 
                fontSize: '1.2rem', 
                fontStyle: 'italic',
                lineHeight: '1.7'
              }}>
                "This checklist was so helpful during an overwhelming time. It helped me gather 
                all the information I needed without forgetting anything important."
              </p>
              <p style={{ color: '#718096', marginTop: '1rem' }}>
                <strong>— Margaret H.</strong>
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default LeadMagnet;

